export const createCharacterGalleryStyles = (theme) => ({
  searchContainer: {
    marginBottom: "24px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
  },
  searchInputContainer: {
    position: "relative",
    maxWidth: "500px",
    margin: "0 auto",
  },
  searchInput: {
    width: "100%",
    padding: "12px 16px 12px 44px",
    fontSize: "16px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "border-color 0.2s ease",
  },
  searchIcon: {
    position: "absolute",
    left: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.textSecondary,
  },
  clearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "4px",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    color: theme.textSecondary,
  },
  searchResults: {
    marginBottom: "32px",
  },
  searchResultsHeader: {
    padding: "16px 24px",
    backgroundColor: theme.primary + "10",
    borderRadius: "12px 12px 0 0",
    border: `2px solid ${theme.primary}`,
    borderBottom: "none",
  },
  searchResultsTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    margin: "0 0 4px 0",
  },
  searchResultsCount: {
    fontSize: "14px",
    color: theme.textSecondary,
    margin: 0,
  },
  searchResultsContent: {
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "0 0 12px 12px",
    border: `2px solid ${theme.primary}`,
    borderTop: "none",
  },
  noResults: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
  },
  container: {
    margin: "0 auto",
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "24px",
    padding: "24px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  headerLeft: {
    display: "flex",
    alignItems: "flex-start",
    gap: "16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: theme.text,
    margin: "0 0 8px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: theme.textSecondary,
    margin: 0,
    lineHeight: "1.5",
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
  },
  toggleAllButton: {
    padding: "12px 20px",
    backgroundColor: theme.primary,
    color: theme.surface,
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  statsBar: {
    display: "flex",
    justifyContent: "center",
    gap: "32px",
    marginBottom: "24px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  schoolContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  schoolSection: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    overflow: "hidden",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  schoolHeader: {
    width: "100%",
    padding: "20px",
    border: "none",
    background: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "all 0.2s ease",
    borderBottom: `1px solid ${theme.border}`,
  },
  schoolHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  schoolTitle: {
    fontSize: "26px",
    fontWeight: "bold",
    color: theme.text,
    margin: 0,
  },
  schoolCount: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "normal",
  },
  schoolHeaderRight: {
    display: "flex",
    alignItems: "center",
  },
  schoolContent: {
    padding: "0 0 20px 0",
  },
  typeSection: {
    marginBottom: "12px",
  },
  typeHeader: {
    width: "calc(100% - 40px)",
    padding: "16px",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    background: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "all 0.2s ease",
    margin: "0 20px",
  },
  typeHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  typeTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    margin: 0,
  },
  characterCount: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "normal",
  },
  typeHeaderRight: {
    display: "flex",
    alignItems: "center",
  },
  charactersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "16px",
    padding: "16px 20px",
  },
  characterCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `1px solid ${theme.border}`,
    overflow: "hidden",
    transition: "all 0.2s ease",
    cursor: "pointer",
    padding: "12px",
  },
  characterCardHover: {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
    borderColor: theme.primary,
  },
  imageContainer: {
    position: "relative",
    height: "240px",
    width: "70%",
    margin: "0 auto",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "12px",
    backgroundColor: theme.background,
  },
  characterImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "12px",
  },
  imagePlaceholder: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.background,
    color: theme.textSecondary,
  },
  placeholderText: {
    fontSize: "14px",
    marginTop: "8px",
  },
  characterInfo: {
    padding: "16px 16px 0 16px",
  },
  characterName: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    margin: "0 0 8px 0",
    lineHeight: "1.3",
  },
});

// Helper function for backward compatibility
export const getCharacterGalleryStyles = (theme) =>
  createCharacterGalleryStyles(theme);
